import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Se adapta a la normativa de mi país?',
    a: 'Sí. El Gabinete está basado en la normativa internacional IEC, que es la base técnica que utilizan la NOM (México), RETIE (Colombia), NTC, AEA (Argentina) y el Reglamento de Baja Tensión.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente tras el pago recibes un correo con los enlaces de descarga.'
  }, {
    q: '¿Es un solo pago?',
    a: 'Sí. No hay mensualidades. Compras hoy y el material es tuyo para siempre.'
  }, {
    q: '¿Puedo editar las evaluaciones?',
    a: 'El material se entrega en formato PDF de alta resolución, listo para imprimir y ser usado como base de cátedra.'
  }, {
    q: '¿Sirve para bachillerato técnico o formación profesional?',
    a: 'Sí, está diseñado para niveles de instrucción técnica media y superior.'
  }, {
    q: '¿Los proyectos integradores incluyen las soluciones?',
    a: 'Sí, los proyectos vienen con toda la documentación técnica resuelta para que el docente tenga la referencia clara al momento de corregir.'
  }, {
    q: '¿Necesito internet para usarlo en clase?',
    a: 'No. Una vez descargados los PDFs, puedes usarlos offline en cualquier dispositivo o imprimirlos.'
  }, {
    q: '¿Puedo compartirlo con mis alumnos?',
    a: 'Sí, puedes imprimir las fichas de trabajo y evaluaciones para repartir en clase o proyectarlas.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tienes 7 días de garantía. Si el material no cumple tus expectativas, solicitas el reembolso y te devolvemos el 100% de tu dinero.'
  }, {
    q: '¿En qué moneda se cobra?',
    a: 'El precio base es en USD, pero al momento de pagar, la plataforma convierte automáticamente el monto a tu moneda local al tipo de cambio oficial del día.'
  }];
  return <section className="py-10 px-4 bg-brand-card" data-id="element-38">
      <div className="max-w-xl mx-auto" data-id="element-39">
        <h2 className="text-xl font-black text-center mb-6 text-white" data-id="element-40">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="flex flex-col gap-2" data-id="element-41">
          {faqs.map((faq, index) => <div key={index} className="bg-brand-dark rounded-md border border-white/5 overflow-hidden" data-id="element-42">
              <button className="w-full p-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-43">
                <span className="font-bold text-sm text-white pr-4" data-id="element-44">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0" data-id="element-45" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0" data-id="element-46" />}
              </button>

              {openIndex === index && <div className="px-4 pb-4" data-id="element-47">
                  <p className="text-sm text-gray-400 pt-2 border-t border-white/5" data-id="element-48">
                    {faq.a}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}